import { kebabCase } from 'lodash';

import { useFirstPaymentPeriodField } from '@makemydeal/dr-dash-components';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const FlexBuyFirstPaymentsRow = () => {
    const { label, value } = useFirstPaymentPeriodField();

    return <ReadOnlyValueRow rowKey="flexBuyFirstPayments" label={label} value={value} labelTestId={kebabCase(label)} />;
};
